import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDP3rXDD-Z6h-6ZGrFXeaJJEOaab-XYZi4",
  authDomain: "micocinavirtual-36484.firebaseapp.com",
  projectId: "micocinavirtual-36484",
  storageBucket: "micocinavirtual-36484.firebasestorage.app",
  messagingSenderId: "627773458544",
  appId: "1:627773458544:web:53b4365d6e4740356b8cb5",
  measurementId: "G-P6YLBPMJMR"
};

export const app = initializeApp(firebaseConfig);
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;
export const db = getFirestore(app);
export const auth = getAuth(app);